import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ParasutBadge() {
  const { selectedTenant } = useAuth();
  const [st, setSt] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const load = () => api.get("/parasut/status", { silent: true }).then((r) => setSt(r.data)).catch(() => setSt(null));
    load();
    window.addEventListener("parasut-status", load);
    return () => window.removeEventListener("parasut-status", load);
  }, [selectedTenant]);
  if (!st?.show) return null;
  const tip = st.ok ? "PARAŞÜT BAĞLI" : st.error || (st.configured ? "BAĞLANTI TEST EDİLMEDİ" : "FİRMA NO / E-POSTA / ŞİFRE EKSİK");
  return (
    <button data-testid="parasut-badge" onClick={() => nav("/ayarlar")} title={tip}
      className={`flex h-9 shrink-0 items-center gap-1.5 rounded-lg border px-2.5 text-xs font-bold ${st.ok ? "border-emerald-700 bg-emerald-950/50 text-emerald-300" : "border-rose-700 bg-rose-950/50 text-rose-300"}`}>
      <span className={`h-2 w-2 rounded-full ${st.ok ? "bg-emerald-400" : "bg-rose-500"}`} /> PARAŞÜT
    </button>
  );
}
